module.exports = __webpack_public_path__ + "static/media/20.758d9519.mp3";